import React, { useEffect } from 'react';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGuestReservations } from '../../../../redux/sagas/routines';
import { getGuestReservationSearchQuery } from '../../../../redux/Guest/selectors/components/reservation-search';
import { updateGuestReservationSearchQuery } from '../../../../redux/Guest/actions/components/reservation-search';
import ReservationList from '../../../../containers/guest/ReservationList';
import ReservationSearch from '../../../../containers/guest/ReservationSearch';

const ReservationSection = ({ guestId, ...props }) => {
  const dispatch = useDispatch();
  const searchQuery = useSelector(getGuestReservationSearchQuery);

  useEffect(() => {
    dispatch(fetchGuestReservations({ guestId, query: searchQuery }));
    dispatch(updateGuestReservationSearchQuery(searchQuery));
  }, []);

  return (
    <Panel {...props}>
      <Panel bordered style={{ marginBottom: 10 }}>
        <ReservationSearch
          guestId={guestId}
          placeholder="Search ID or Outreach"
        />
      </Panel>
      <ReservationList guestId={guestId} />
    </Panel>
  );
};

ReservationSection.propTypes = {
  guestId: PropTypes.number.isRequired
};

export default ReservationSection;
